//Generated File 
export default class SortType{
	static readonly Ascending = `Ascending`;
	static readonly Descending = `Descending`;
}
